import * as React from 'react';
const CalenderIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={23} height={24} fill="none" {...props}>
    <path
      fill={props.color}
      d="M0 7.772v-.958a4.797 4.797 0 0 1 4.792-4.792h.958v-.958a.958.958 0 1 1 1.917 0v.958h7.666v-.958a.958.958 0 1 1 1.917 0v.958h.958A4.797 4.797 0 0 1 23 6.814v.958H0ZM23 9.69v8.625a4.797 4.797 0 0 1-4.792 4.791H4.792A4.797 4.797 0 0 1 0 18.314V9.689h23Zm-11.5 8.625a.958.958 0 0 0-.958-.959H5.75a.958.958 0 1 0 0 1.917h4.792c.53 0 .958-.43.958-.958Zm6.708-3.834a.958.958 0 0 0-.958-.958H5.75a.958.958 0 1 0 0 1.917h11.5c.53 0 .958-.43.958-.959Z"
    />
  </svg>
);
export default CalenderIcon;
